import type { ActorProfile } from '../domain/types';

export interface PublicSupporter {
  did?: string;
  handle: string;
}

export async function loadSupporters(signal?: AbortSignal): Promise<PublicSupporter[]> {
  const response = await fetch('../supporters.php', { signal });
  if (!response.ok) return [];
  const value = await response.json();
  return Array.isArray(value?.supporters) ? value.supporters : [];
}

export function isSupporter(
  supporters: PublicSupporter[] | undefined,
  actor: Pick<ActorProfile, 'did' | 'handle'>,
): boolean {
  const handle = actor.handle.toLowerCase();
  return supporters?.some(supporter => (
    supporter.did === actor.did || supporter.handle === handle
  )) || false;
}
